import React from 'react';
import {FormattedMessage} from "react-intl";

import {Tooltip} from "@mui/material";

import {CloudDownload} from "@mui/icons-material";

function PrestashopDisabledButton(props) {
    return (
        <Tooltip title={<FormattedMessage id={"feed.list.table.tooltip.prestashop.noLocale"} />}>
            <CloudDownload color="disabled"/>
        </Tooltip>
    );
}

export default PrestashopDisabledButton;
